module.exports = __webpack_public_path__ + "fonts/perfect-serve.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/@ps/common-core/dist/fonts/perfect-serve.ttf
// module id = ./node_modules/@ps/common-core/dist/fonts/perfect-serve.ttf
// module chunks = 1